import Alert from "./Alert";
import { FoundryError } from "../lib/foundry_client/errors";

interface ErrorsListProps {
  errors: FoundryError[];
  title: string;
  children?: any;
}

export default function ErrorsList(props: ErrorsListProps) {
  return (
    <Alert title={props.title} color="red">
      {props.children}
      {props.errors && (
        <ul>
          {props.errors.map((error) => {
            return <li>{error.message}</li>;
          })}
        </ul>
      )}
    </Alert>
  );
}
